export default __webpack_public_path__ + "static/media/illustration.092ac116.svg";